import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface User {
  user: {
    username: string;
    email: string;
    phone: string;
    avatar: string;
    apple_name: string;
    google_name: string;
    google_avatar: string;
    tariff?: string;
    attempts?: number;
    rankedRequests?: number;
    selectedRequests?: number;
  };
  tokens: {
    access_token: string;
  };
}

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  isUpdateAccesToken: boolean;
  setUser: (user: User | null) => void;
  clearUser: () => void;
  setIsAuthenticated: (isAuthenticated: string) => void;
  updateAccessToken: (newAccessToken: string) => void;
  setFlagUpdateToken: (flag: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      isAuthenticated: false,
      isUpdateAccesToken: false,
      user: null,
      setUser: (user) =>
        set({
          isAuthenticated: !!user,
          user,
        }),
      clearUser: () =>
        set({
          isAuthenticated: false,
          user: null,
        }),
      setIsAuthenticated: (isAuthenticated: string) =>
        set({
          isAuthenticated:
            isAuthenticated === "false"
              ? false
              : isAuthenticated
              ? true
              : false,
        }),
      updateAccessToken: (newAccessToken: string) => {
        const currentUser = get().user;
        const setFlagUpdateToken = get().setFlagUpdateToken;
        if (!currentUser) return;

        set({
          user: {
            ...currentUser,
            tokens: {
              access_token: newAccessToken,
            },
          },
        });
        setFlagUpdateToken(false);
      },
      setFlagUpdateToken: (flag: boolean) => {
        set({ isUpdateAccesToken: flag });
      },
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
